// extracted by mini-css-extract-plugin
export default {"overlayLoader":"ZczE7O","message":"LfuAuv","icon":"lj0ypt"};